/**
 * Skeleton size tokens — maps semantic element names to Tailwind height classes.
 * Use these inside Skeleton components to keep skeleton proportions consistent
 * with real UI elements.
 *
 * Usage:
 *   import { skeletonSizes } from '@/design-system/skeleton-tokens';
 *   <Skeleton className={skeletonSizes.input} />
 */
export const skeletonSizes = {
  /** h-3 — 12px — body text line */
  text: 'h-3',
  /** h-4 — 16px — card/section title, label */
  title: 'h-4',
  /** h-3.5 — 14px — secondary text / badge row */
  subtext: 'h-3.5',
  /** h-9 — 36px — standard text input / select */
  input: 'h-9',
  /** h-8 — 32px — compact input / button */
  button: 'h-8',
  /** h-10 — 40px — large input / search bar */
  inputLg: 'h-10',
  /** h-24 — 96px — card body block */
  card: 'h-24',
  /** h-48 — 192px — chart / large content area */
  chart: 'h-48',
  /** h-64 — 256px — tall chart / hero block */
  chartLg: 'h-64',
  /** h-2 — 8px — thin divider / progress bar */
  bar: 'h-2',
} as const;

export type SkeletonSizeKey = keyof typeof skeletonSizes;
